export const ACCESS_TOKEN = "demoa1b2c3";

export const fnbStore = ["HUDSON", "ALLPRESS CAFE", "AROHA"];

export const conditionMapping = {
  none: null,
  "==": "equal",
  "<": "less_than",
  "<=": "less_than_equal",
  ">": "greater_than",
  ">=": "greater_than_equal",
};

export const priceRange = ["none", "cheapest", "midrange", "expensive"];

export const sortingMapping = {
  "Price - Low to High": "price_low_to_high",
  "Price - High to Low": "price_high_to_low",
  "Price Rank - Asc": "pricerank_low_to_high",
  "Price Rank - Dsc": "pricerank_high_to_low",
  "Difference - Low to High": "difference_low_to_high",
  "Difference - High to Low": "difference_high_to_low",
  "Difference % - Low to High": "difference_percentage_low_to_high",
  "Difference % - High to Low": "difference_percentage_high_to_low",
};

export const locationMapping = {
  aelia_auckland: {
    location: "Auckland",
    brand: "Auckland dutyfree",
    type: "Duty Free",
    currency: "NZD",
  },
  aelia_queenstown: {
    location: "Queenstown",
    brand: "Aelia",
    type: "Duty Free",
    currency: "NZD",
  },
  aelia_christchurch: {
    location: "Christchurch",
    brand: "Aelia",
    type: "Duty Free",
    currency: "NZD",
  },
  lotte_brisbane: {
    location: "Brisbane",
    brand: "Lotte",
    type: "Duty Free",
    currency: "AUD",
  },
  lotte_melbourne: {
    location: "Melbourne",
    brand: "Lotte",
    type: "Duty Free",
    currency: "AUD",
  },
  heinemann_sydney: {
    location: "Sydney",
    brand: "Heinemann",
    type: "Duty Free",
    currency: "AUD",
  },
  sephora: {
    location: "Auckland",
    brand: "Sephora",
    type: "Domestic",
    currency: "NZD",
  },
  beauty_bliss: {
    location: "Auckland",
    brand: "Beauty bliss",
    type: "Domestic",
    currency: "NZD",
  },
  farmers: {
    location: "Auckland",
    brand: "Farmers",
    type: "Domestic",
    currency: "NZD",
  },
  nz_liquor: {
    location: "Auckland",
    brand: "NZ liquor",
    type: "Domestic",
    currency: "NZD",
  },
  big_barrel: {
    location: "Auckland",
    brand: "Big Barrel",
    type: "Domestic",
    currency: "NZD",
  },
  chemist_warehouse: {
    location: "Auckland",
    brand: "Chemist Warehouse",
    type: "Domestic",
    currency: "NZD",
  },
  whisky_and_more: {
    location: "Auckland",
    brand: "Whisky and more",
    type: "Domestic",
    currency: "NZD",
  },
  mecca: {
    location: "Auckland",
    brand: "mecca",
    type: "Domestic",
    currency: "NZD",
  },
  aelia_adelaide: {
    location: "Adelaide",
    brand: "Aelia",
    type: "Duty Free",
    currency: "AUD",
  },
  aelia_cairns: {
    location: "Cairns",
    brand: "Aelia",
    type: "Duty Free",
    currency: "AUD",
  },
  au_chemist_warehouse: {
    location: "Australia",
    brand: "Chemist Warehouse",
    type: "Domestic",
    currency: "AUD",
  },
  au_mecca: {
    location: "Australia",
    brand: "Mecca",
    type: "Domestic",
    currency: "AUD",
  },
  au_sephora: {
    location: "Australia",
    brand: "Sephora",
    type: "Domestic",
    currency: "AUD",
  },
  the_iconic: {
    location: "Australia",
    brand: "The Iconic",
    type: "Domestic",
    currency: "AUD",
  },
  danmurphy: {
    location: "Australia",
    brand: "Dan Murphy",
    type: "Domestic",
    currency: "AUD",
  },
  heinemann_goldcoast: {
    location: "Gold Coast",
    brand: "Heinemann",
    type: "Duty Free",
    currency: "AUD",
  },
  nz_themall: {
    location: "Auckland",
    brand: "The Mall",
    type: "Domestic",
    currency: "NZD",
  },
  liquorland: {
    location: "Auckland",
    brand: "Liquorland",
    type: "Domestic",
    currency: "NZD",
  },
  lifepharmacy: {
    location: "Auckland",
    brand: "Life Pharmacy",
    type: "Domestic",
    currency: "NZD",
  },
  ishopchangi: {
    location: "Singapore",
    brand: "iShopChangi",
    type: "Duty Free",
    currency: "SGD",
  },
};

export const sortingSteps = [
  "Price - Low to High",
  "Price - High to Low",
  "Price Rank - Asc",
  "Price Rank - Dsc",
  "Difference - Low to High",
  "Difference - High to Low",
  "Difference % - Low to High",
  "Difference % - High to Low",
];
export const terminalSteps = [
  "DOMESTIC AIRSIDE",
  "DOMESTIC LANDSIDE",
  "INTL AIRSIDE",
  "INTL LANDSIDE",
];
export const storeSteps = [
  "Allpress café (INTL LANDSIDE)",
  "Aroha (INTL AIRSIDE)",
  "Best Ugly Bagels (INTL AIRSIDE)",
  "Better Burger (INTL AIRSIDE)",
  "Bistro Box (DOMESTIC LANDSIDE)",
  "Bistro Box (DOMESTIC AIRSIDE)",
  "Bistro Box Caravan (INTL AIRSIDE)",
  "Blue Marble (INTL LANDSIDE)",
  "Gipsy Moth (DOMESTIC LANDSIDE)",
  "Halong Bay (INTL AIRSIDE)",
  "Hayama Sushi & Noodle (INTL AIRSIDE)",
  "Hayama Sushi & Noodle (INTL LANDSIDE)",
  "Hikari (DOMESTIC LANDSIDE)",
  "Hudsons (DOMESTIC AIRSIDE)",
  "KFC (INTL LANDSIDE)",
  "Little Italy (INTL AIRSIDE)",
  "McDonalds (INTL AIRSIDE)",
  "McDonalds (INTL LANDSIDE)",
  "McDonalds (DOMESTIC LANDSIDE)",
  "Mexico (INTL AIRSIDE)",
  "Oma (INTL LANDSIDE)",
  "Orleans Chicken & Waffles (DOMESTIC LANDSIDE)",
  "Pita Pit (INTL LANDSIDE)",
  "Popo Dumplings (INTL AIRSIDE)",
  "Relay (INTL LANDSIDE)",
  "Relay (INTL AIRSIDE)",
  "Relay (DOMESTIC LANDSIDE)",
  "Relay Café (DOMESTIC LANDSIDE)",
  "Silk Road (INTL LANDSIDE)",
  "Silk Road (DOMESTIC LANDSIDE)",
  "Soul Origin (DOMESTIC LANDSIDE)",
  "Take Home (INTL LANDSIDE)",
  "Tank (INTL LANDSIDE)",
  "Tea Garden (INTL AIRSIDE)",
  "Tost (INTL LANDSIDE)",
  "Vantage Bar (INTL AIRSIDE)",
  "Wondertree (INTL AIRSIDE)",
];
export const categorySteps = ["liquor", "beauty","confectionery"];
export const brandSteps = ["expres", "trixie cosmetics", "silver bullet"];
export const locationSteps = [
  // "auckland",
  "christchurch",
  "queenstown",
  "sydeny",
  "brisbane",
  "melbourne",
  "beauty_bliss",
  "bigbarrel",
  "farmers",
  "mecca",
  "nzliquor",
  "sephora",
];
export const conditionSteps = ["none", "==", "<", "<=", ">", ">="];
export const rowCounts = [10, 25, 50, 100];

export const storeData = [
  {
    title: "Aroha",
    terminal: "INTL AIRSIDE",
    pricerank: "1 / 1",
    tp: {
      value: 7,
      change: 1,
      isUp: false,
    },
    ep: {
      value: 3,
      change: 0,
      isUp: true,
    },
    mp: {
      value: 3,
      change: 1,
      isUp: false,
    },
    cp: {
      value: 1,
      change: 0,
      isUp: true,
    },
  },
  {
    title: "Hudson",
    terminal: "DOMESTIC",
    pricerank: "1 / 1",
    tp: {
      value: 7,
      change: 2,
      isUp: false,
    },
    ep: {
      value: 2,
      change: 0,
      isUp: true,
    },
    mp: {
      value: 3,
      change: 1,
      isUp: false,
    },
    cp: {
      value: 2,
      change: 1,
      isUp: false,
    },
  },
  {
    title: "Allpress Cafe",
    terminal: "INTL LANDSIDE",
    pricerank: "1 / 1",
    tp: {
      value: 4,
      change: 0,
      isUp: true,
    },
    ep: {
      value: 0,
      change: 1,
      isUp: false,
    },
    mp: {
      value: 3,
      change: 1,
      isUp: true,
    },
    cp: {
      value: 1,
      change: 0,
      isUp: true,
    },
  },
];
export const productData = [
  {
    title: "Chicken Sandwich",
    brand: "AROHA",
    pricerank: "9 / 9",
    price: 16.0,
    avg: 12.33,
    diff: 3.77,
    diffper: 23.56,
    terminal: "Intl Airside",
    id: 0,
    type: "Food - cabinet",
    details: [
      {
        title: "Chicken Sandwich",
        brand: "Esquires, Westfield Manukau",
        price: 7.2,
        diff: 8.8,
        notes: "With extra sauces",
        data: [7.2, 7.2],
      },
      {
        title: "Chicken Sandwich",
        brand: "Muffin Break. Manukau",
        price: 7.5,
        diff: 8.5,
        notes: "NA",
        data: [9.9, 7.5],
      },
      {
        title: "Chicken Sandwich",
        brand: "Gloria Jeans, Manukau",
        price: 8.5,
        diff: 7.5,
        notes: "NA",
        data: [8.5, 8.5],
      },
      {
        title: "Chicken Sandwich",
        brand: "Columbus Coffee, Sylvia Park",
        price: 12.5,
        diff: 3.5,
        notes: "NA",
        data: [12.5, 12.5],
      },
      {
        title: "Chicken Sandwich",
        brand: "Jamaica Blue, Leonard Issit Drive",
        price: 13.9,
        diff: 2.1,
        notes: "NA",
        data: [13.9, 13.9],
      },
      {
        title: "Chicken Sandwich",
        brand: "Allpress Café- International Landside",
        price: 14.0,
        diff: 2.0,
        notes: "NA",
        data: [14.0, 14.0],
      },
      {
        title: "Chicken Sandwich",
        brand: "Kawau Kitchen, Leonard Issit Drive",
        price: 14.5,
        diff: 1.5,
        notes: "NA",
        data: [11.5, 14.5],
      },
      {
        title: "Chicken Sandwich",
        brand: "Hudson Akl Airport",
        price: 16.0,
        diff: 0.0,
        notes: "NA",
        data: [16.0, 16.0],
      },
      {
        title: "Chicken Sandwich",
        brand: "Aroha",
        price: 16.0,
        diff: 0.0,
        notes: "NA",
        data: [16.0, 16.0],
      },
    ],
  },
  {
    title: "Mince Pie",
    brand: "AROHA",
    pricerank: "7 / 7",
    price: 12.0,
    avg: 9.25,
    diff: 2.75,
    diffper: 22.91,
    terminal: "Intl Airside",
    id: 1,
    type: "Food - cabinet",
    details: [
      {
        title: "Mince Pie",
        brand: "Muffin Break Manukau",
        price: 6.9,
        diff: 5.1,
        notes: "NA",
        data: [8, 6.9],
      },
      {
        title: "Mince Pie",
        brand: "Esquires, Westfield Manukau",
        price: 7.2,
        diff: 4.8,
        notes: "NA",
        data: [7.2, 7.2],
      },
      {
        title: "Mince Pie",
        brand: "Jamaica Blue, Leonard Issit Drive",
        price: 7.9,
        diff: 4.1,
        notes: "NA",
        data: [10.5, 7.9],
      },
      {
        title: "Mince Pie",
        brand: "Gloria Jeans, Manukau",
        price: 7.9,
        diff: 4.1,
        notes: "NA",
        data: [7.9, 7.9],
      },
      {
        title: "Mince Pie",
        brand: "Kawau Kitchen, Leonard Issit Drive",
        price: 10.9,
        diff: 1.1,
        notes: "NA",
        data: [9.5, 10.9],
      },
      {
        title: "Mince Pie",
        brand: "Hudson Akl Airport",
        price: 12.0,
        diff: 0,
        notes: "NA",
        data: [12, 12],
      },
      {
        title: "Mince Pie",
        brand: "Aroha",
        price: 12.0,
        diff: 0,
        notes: "NA",
        data: [12, 12],
      },
    ],
  },
  {
    title: "Scone",
    brand: "AROHA",
    pricerank: "4 / 7",
    price: 6.0,
    avg: 6.34,
    diff: -0.34,
    diffper: -5.6,
    terminal: "Intl Airside",
    id: 2,
    type: "Food - cabinet",
    details: [
      {
        title: "Scone",
        brand: "Muffin Break. Manukau",
        price: 5.3,
        diff: 0.7,
        notes: "NA",
        data: [6, 5.3],
      },
      {
        title: "Scone",
        brand: "Esquires, Westfield Manukau",
        price: 5.9,
        diff: 0.1,
        notes: "NA",
        data: [5.9, 5.9],
      },
      {
        title: "Scone",
        brand: "Gloria Jeans, Manukau",
        price: 6.0,
        diff: 0,
        notes: "NA",
        data: [6, 6],
      },
      {
        title: "Scone",
        brand: "Aroha",
        price: 6.0,
        diff: 0,
        notes: "NA",
        data: [6, 6],
      },
      {
        title: "Scone",
        brand: "Jamaica Blue, Leonard Issit Drive",
        price: 7.0,
        diff: -1.0,
        notes: "NA",
        data: [7, 7],
      },
      {
        title: "Scone",
        brand: "Hudson Akl Airport",
        price: 7.0,
        diff: -1.0,
        notes: "NA",
        data: [7, 7],
      },
      {
        title: "Scone",
        brand: "Columbus Coffee, Sylvia Park",
        price: 7.2,
        diff: -1.2,
        notes: "NA",
        data: [7.2, 7.2],
      },
    ],
  },
  {
    title: "Almond Croissant",
    brand: "AROHA",
    pricerank: "5 / 6",
    price: 9.0,
    avg: 8.38,
    diff: 0.62,
    diffper: 6.8,
    terminal: "Intl Airside",
    id: 3,
    type: "Food - cabinet",
    details: [
      {
        title: "Almond Croissant",
        brand: "Gloria Jeans, Manukau",
        price: 6.9,
        diff: 2.1,
        notes: "NA",
        data: [6.9, 6.9],
      },
      {
        title: "Almond Croissant",
        brand: "Jamaica Blue, Leonard Issit Drive",
        price: 7.9,
        diff: 1.1,
        notes: "NA",
        data: [8.9, 7.9],
      },
      {
        title: "Almond Croissant",
        brand: "Muffin Break. Manukau",
        price: 8.5,
        diff: 0.5,
        notes: "NA",
        data: [8.5, 8.5],
      },
      {
        title: "Almond Croissant",
        brand: "Columbus Coffee, Sylvia Park",
        price: 8.5,
        diff: 0.5,
        notes: "NA",
        data: [8.5, 8.5],
      },
      {
        title: "Almond Croissant",
        brand: "Aroha",
        price: 9.0,
        diff: 0,
        notes: "NA",
        data: [9, 9],
      },
      {
        title: "Almond Croissant",
        brand: "Kawau Kitchen, Leonard Issit Drive",
        price: 9.5,
        diff: -0.5,
        notes: "NA",
        data: [9.5, 9.5],
      },
    ],
  },
  {
    title: "Fruit cup",
    brand: "AROHA",
    pricerank: "2 / 4",
    price: 8.5,
    avg: 8.82,
    diff: -0.32,
    diffper: -3.7,
    terminal: "Intl Airside",
    id: 4,
    type: "Food - cabinet",
    details: [
      {
        title: "Fruit cup",
        brand: "Hudson Akl Airport",
        price: 8.0,
        diff: 0.5,
        notes: "NA",
        data: [8, 8],
      },
      {
        title: "Fruit cup",
        brand: "Aroha",
        price: 8.5,
        diff: 0,
        notes: "NA",
        data: [8.5, 8.5],
      },
      {
        title: "Fruit cup",
        brand: "Columbus Coffee, Sylvia Park",
        price: 8.9,
        diff: -0.4,
        notes: "NA",
        data: [8.9, 8.9],
      },
      {
        title: "Fruit cup",
        brand: "Majestic Café,Sylvia Park",
        price: 9.9,
        diff: -1.4,
        notes: "NA",
        data: [9.9, 9.9],
      },
    ],
  },
  {
    title: "Cereal & yoghurt cup",
    brand: "AROHA",
    pricerank: "4 / 4",
    price: 12.0,
    avg: 10.7,
    diff: 1.3,
    diffper: 10.8,
    terminal: "Intl Airside",
    id: 5,
    type: "Food - cabinet",
    details: [
      {
        title: "Cereal & yoghurt cup",
        brand: "Majestic Café,Sylvia Park",
        price: 9.9,
        diff: 2.1,
        notes: "NA",
        data: [9.9, 9.9],
      },
      {
        title: "Cereal & yoghurt cup",
        brand: "Columbus Coffee, Sylvia Park",
        price: 9.9,
        diff: 2.1,
        notes: "NA",
        data: [9.9, 9.9],
      },
      {
        title: "Cereal & yoghurt cup",
        brand: "Jamaica Blue, Leonard Issit Drive",
        price: 11.0,
        diff: 1.0,
        notes: "NA",
        data: [11, 11],
      },
      {
        title: "Cereal & yoghurt cup",
        brand: "Aroha",
        price: 12.0,
        diff: 0,
        notes: "NA",
        data: [12, 12],
      },
    ],
  },
  {
    title: "Flat white - medium",
    brand: "AROHA",
    pricerank: "1 / 6",
    price: 6.0,
    avg: 6.2,
    diff: -0.2,
    diffper: -3.33,
    terminal: "Intl Airside",
    id: 6,
    type: "Drink",
    details: [
      {
        title: "Flat white - medium",
        brand: "Aroha",
        price: 6.0,
        diff: 0,
        notes: "NA",
        data: [5.5, 6],
      },
      {
        title: "Flat white - medium",
        brand: "Kawau Kitchen, Leonard Issit Drive",
        price: 6.0,
        diff: 0,
        notes: "NA",
        data: [6, 6],
      },
      {
        title: "Flat white - medium",
        brand: "Muffin Break. Manukau",
        price: 6.3,
        diff: -0.3,
        notes: "NA",
        data: [6.3, 6.3],
      },
      {
        title: "Flat white - medium",
        brand: "Gloria Jeans, Manukau",
        price: 6.3,
        diff: -0.3,
        notes: "NA",
        data: [6.3, 6.3],
      },
      {
        title: "Flat white - medium",
        brand: "Esquires, Westfield Manukau",
        price: 6.3,
        diff: -0.3,
        notes: "NA",
        data: [6.3, 6.3],
      },
      {
        title: "Flat white - medium",
        brand: "Jamaica Blue, Leonard Issit Drive",
        price: 6.3,
        diff: -0.3,
        notes: "NA",
        data: [6.3, 6.3],
      },
    ],
  },
  {
    title: "Mince Pie",
    brand: "HUDSON",
    pricerank: "7 / 7",
    price: 12.0,
    avg: 9.26,
    diff: 2.74,
    diffper: 22.83,
    terminal: "Domestic",
    id: 7,
    type: "Food - cabinet",
    details: [
      {
        title: "Mince Pie",
        brand: "Muffin Break Manukau",
        price: 6.9,
        diff: 5.1,
        notes: "NA",
        data: [8, 6.9],
      },
      {
        title: "Mince Pie",
        brand: "Esquires, Westfield Manukau",
        price: 7.2,
        diff: 4.8,
        notes: "NA",
        data: [7.2, 7.2],
      },
      {
        title: "Mince Pie",
        brand: "Jamaica Blue, Leonard Issit Drive",
        price: 7.9,
        diff: 4.1,
        notes: "NA",
        data: [10.5, 7.9],
      },
      {
        title: "Mince Pie",
        brand: "Gloria Jeans, Manukau",
        price: 7.9,
        diff: 4.1,
        notes: "NA",
        data: [7.9, 7.9],
      },
      {
        title: "Mince Pie",
        brand: "Kawau Kitchen, Leonard Issit Drive",
        price: 10.9,
        diff: 1.1,
        notes: "NA",
        data: [9.5, 10.9],
      },
      {
        title: "Mince Pie",
        brand: "Aroha Café- Airside",
        price: 12.0,
        diff: 0,
        notes: "NA",
        data: [12, 12],
      },
      {
        title: "Mince Pie",
        brand: "Hudson",
        price: 12.0,
        diff: 0,
        notes: "NA",
        data: [12, 12],
      },
    ],
  },
  {
    title: "Chicken Sandwich",
    brand: "HUDSON",
    pricerank: "9 / 9",
    price: 16.0,
    avg: 12.33,
    diff: 3.77,
    diffper: 23.56,
    terminal: "Domestic",
    id: 8,
    type: "Food - cabinet",
    details: [
      {
        title: "Chicken Sandwich",
        brand: "Esquires, Westfield Manukau",
        price: 7.2,
        diff: 8.8,
        notes: "NA",
        data: [7.2, 7.2],
      },
      {
        title: "Chicken Sandwich",
        brand: "Muffin Break Manukau",
        price: 7.5,
        diff: 4.5,
        notes: "NA",
        data: [9.9, 7.5],
      },
      {
        title: "Chicken Sandwich",
        brand: "Gloria Jeans, Manukau",
        price: 8.5,
        diff: 3.5,
        notes: "NA",
        data: [8.5, 8.5],
      },
      {
        title: "Chicken Sandwich",
        brand: "Columbus Coffee, Sylvia Park",
        price: 12.5,
        diff: 3.5,
        notes: "NA",
        data: [11.9, 12.5],
      },
      {
        title: "Chicken Sandwich",
        brand: "Jamaica Blue, Leonard Issit Drive",
        price: 13.9,
        diff: 2.1,
        notes: "NA",
        data: [13.9, 13.9],
      },
      {
        title: "Chicken Sandwich",
        brand: "Allpress Café- International Landside",
        price: 14.0,
        diff: 2.0,
        notes: "NA",
        data: [14, 14],
      },
      {
        title: "Chicken Sandwich",
        brand: "Kawau Kitchen, Leonard Issit Drive",
        price: 14.5,
        diff: 2.0,
        notes: "NA",
        data: [11.5, 14.5],
      },
      {
        title: "Chicken Sandwich",
        brand: "Aroha Café- Airside",
        price: 16.0,
        diff: 0,
        notes: "NA",
        data: [16, 16],
      },
      {
        title: "Chicken Sandwich",
        brand: "Hudson",
        price: 16.0,
        diff: 0,
        notes: "NA",
        data: [16, 16],
      },
    ],
  },
  {
    title: "Scone",
    brand: "HUDSON",
    pricerank: "5 / 7",
    price: 7.0,
    avg: 6.34,
    diff: 0.66,
    diffper: 9.4,
    terminal: "Domestic",
    id: 9,
    type: "Food - cabinet",
    details: [
      {
        title: "Scone",
        brand: "Muffin Break Manukau",
        price: 5.3,
        diff: 1.7,
        notes: "NA",
        data: [6, 5.3],
      },
      {
        title: "Scone",
        brand: "Esquires, Westfield Manukau",
        price: 5.9,
        diff: 1.1,
        notes: "NA",
        data: [5.9, 5.9],
      },
      {
        title: "Scone",
        brand: "Aroha Café- Airside",
        price: 6.0,
        diff: 1.0,
        notes: "NA",
        data: [6, 6],
      },
      {
        title: "Scone",
        brand: "Gloria Jeans, Manukau",
        price: 6,
        diff: 1.0,
        notes: "NA",
        data: [6, 6],
      },
      {
        title: "Scone",
        brand: "Hudson",
        price: 7.0,
        diff: 0,
        notes: "NA",
        data: [7, 7],
      },
      {
        title: "Scone",
        brand: "Jamaica Blue, Leonard Issit Drive",
        price: 7.0,
        diff: 0,
        notes: "NA",
        data: [7, 7],
      },
      {
        title: "Scone",
        brand: "Columbus Coffee, Sylvia Park",
        price: 7.2,
        diff: -0.2,
        notes: "NA",
        data: [7.2, 7.2],
      },
    ],
  },
  {
    title: "Sausage Roll",
    brand: "HUDSON",
    pricerank: "5 / 6",
    price: 8.0,
    avg: 7.53,
    diff: 0.47,
    diffper: 4.87,
    terminal: "Domestic",
    id: 10,
    type: "Food - cabinet",
    details: [
      {
        title: "Sausage Roll",
        brand: "Gloria Jeans, Manukau",
        price: 5.3,
        diff: 2.7,
        notes: "NA",
        data: [5.3, 5.3],
      },
      {
        title: "Sausage Roll",
        brand: "Muffin Break Manukau",
        price: 6.9,
        diff: 1.1,
        notes: "NA",
        data: [6.9, 6.9],
      },
      {
        title: "Sausage Roll",
        brand: "Esquires, Westfield Manukau",
        price: 7.2,
        diff: 0.8,
        notes: "NA",
        data: [7.2, 7.2],
      },
      {
        title: "Sausage Roll",
        brand: "Jamaica Blue, Leonard Issit Drive",
        price: 7.9,
        diff: 0.1,
        notes: "NA",
        data: [9, 7.9],
      },
      {
        title: "Sausage Roll",
        brand: "Hudson",
        price: 8.0,
        diff: 0,
        notes: "NA",
        data: [8, 8],
      },
      {
        title: "Sausage Roll",
        brand: "Kawau Kitchen, Leonard Issit Drive",
        price: 9.9,
        diff: -1.9,
        notes: "NA",
        data: [9.5, 9.9],
      },
    ],
  },
  {
    title: "Wrap",
    brand: "HUDSON",
    pricerank: "8 / 8",
    price: 16.0,
    avg: 12.53,
    diff: 3.47,
    diffper: 21.68,
    terminal: "Domestic",
    id: 11,
    type: "Food - cabinet",
    details: [
      {
        title: "Wrap",
        brand: "Muffin Break Manukau",
        price: 8.5,
        diff: 7.5,
        notes: "NA",
        data: [9.9, 8.5],
      },
      {
        title: "Wrap",
        brand: "Allpress Café- International Landside",
        price: 11.0,
        diff: 5.0,
        notes: "NA",
        data: [11, 11],
      },
      {
        title: "Wrap",
        brand: "Aroha Café- Airside",
        price: 11.0,
        diff: 5.0,
        notes: "NA",
        data: [11, 11],
      },
      {
        title: "Wrap",
        brand: "Gloria Jeans, Manukau",
        price: 11.9,
        diff: 4.1,
        notes: "NA",
        data: [11.9, 11.9],
      },
      {
        title: "Wrap",
        brand: "Kawau Kitchen, Leonard Issit Drive",
        price: 11.9,
        diff: 4.1,
        notes: "NA",
        data: [13.5, 11.9],
      },
      {
        title: "Wrap",
        brand: "Esquires, Westfield Manukau",
        price: 14.5,
        diff: 1.5,
        notes: "NA",
        data: [14.5, 14.5],
      },
      {
        title: "Wrap",
        brand: "Jamaica Blue, Leonard Issit Drive",
        price: 15.5,
        diff: 0.5,
        notes: "NA",
        data: [13.5, 15.5],
      },
      {
        title: "Wrap",
        brand: "Hudson",
        price: 16.0,
        diff: 0.0,
        notes: "NA",
        data: [14, 16],
      },
    ],
  },
  {
    title: "Fruit Cup",
    brand: "HUDSON",
    pricerank: "1 / 4",
    price: 8.0,
    avg: 8.82,
    diff: -0.82,
    diffper: 10.25,
    terminal: "Domestic",
    id: 12,
    type: "Food - cabinet",
    details: [
      {
        title: "Fruit Cup",
        brand: "Hudson",
        price: 8.0,
        diff: 0,
        notes: "NA",
        data: [8, 8],
      },
      {
        title: "Fruit Cup",
        brand: "Aroha Café- Airside",
        price: 8.5,
        diff: -0.5,
        notes: "NA",
        data: [8.5, 8.5],
      },
      {
        title: "Fruit Cup",
        brand: "Columbus Coffee, Sylvia Park",
        price: 8.9,
        diff: -0.9,
        notes: "NA",
        data: [8.9, 8.9],
      },
      {
        title: "Fruit Cup",
        brand: "Majestic Café,Sylvia Park",
        price: 9.9,
        diff: -1.9,
        notes: "NA",
        data: [9.9, 9.9],
      },
    ],
  },
  {
    title: "Flat white - medium",
    brand: "HUDSON",
    pricerank: "2 / 7",
    price: 6.0,
    avg: 6.14,
    diff: -0.14,
    diffper: 2.33,
    terminal: "Domestic",
    id: 13,
    type: "Drink",
    details: [
      {
        title: "Flat white - medium",
        brand: "Allpress Café- International Landside",
        price: 5.9,
        diff: 0.1,
        notes: "NA",
        data: [5.9, 5.9],
      },
      {
        title: "Flat white - medium",
        brand: "Hudson",
        price: 6.0,
        diff: 0,
        notes: "NA",
        data: [6, 6],
      },
      {
        title: "Flat white - medium",
        brand: "Aroha Café- Airside",
        price: 6.0,
        diff: 0,
        notes: "NA",
        data: [6, 6],
      },
      {
        title: "Flat white - medium",
        brand: "Muffin Break Manukau",
        price: 6.3,
        diff: -0.3,
        notes: "NA",
        data: [6.3, 6.3],
      },
      {
        title: "Flat white - medium",
        brand: "Gloria Jeans, Manukau",
        price: 6.3,
        diff: -0.3,
        notes: "NA",
        data: [6.3, 6.3],
      },
      {
        title: "Flat white - medium",
        brand: "Esquires, Westfield Manukau",
        price: 6.3,
        diff: -0.3,
        notes: "NA",
        data: [6.3, 6.3],
      },
      {
        title: "Flat white - medium",
        brand: "Jamaica Blue, Leonard Issit Drive",
        price: 6.3,
        diff: -0.3,
        notes: "NA",
        data: [6.3, 6.3],
      },
    ],
  },
  {
    title: "Wrap",
    brand: "ALLPRESS CAFE",
    pricerank: "6 / 8",
    price: 11.0,
    avg: 12.54,
    diff: -1.54,
    diffper: 14.0,
    terminal: "Intl Landside",
    id: 14,
    type: "Food - cabinet",
    details: [
      {
        title: "Wrap",
        brand: "Muffin Break Manukau",
        price: 8.5,
        diff: 2.5,
        notes: "NA",
        data: [9.9, 8.5],
      },
      {
        title: "Wrap",
        brand: "Allpress Cafe",
        price: 11.0,
        diff: 0,
        notes: "NA",
        data: [11, 11],
      },
      {
        title: "Wrap",
        brand: "Aroha Café- Airside",
        price: 11.0,
        diff: 0,
        notes: "NA",
        data: [11, 11],
      },
      {
        title: "Wrap",
        brand: "Kawau Kitchen, Leonard Issit Drive",
        price: 11.9,
        diff: -0.9,
        notes: "NA",
        data: [13.5, 11.9],
      },
      {
        title: "Wrap",
        brand: "Gloria  Jeans Manukau",
        price: 11.9,
        diff: -0.9,
        notes: "NA",
        data: [11.9, 11.9],
      },
      {
        title: "Wrap",
        brand: "Esquires, Westfield Manukau",
        price: 14.5,
        diff: -3.5,
        notes: "NA",
        data: [14.5, 14.5],
      },
      {
        title: "Wrap",
        brand: "Jamaica Blue, Leonard Issit Drive",
        price: 15.5,
        diff: -4.5,
        notes: "NA",
        data: [13.5, 15.5],
      },
      {
        title: "Wrap",
        brand: "Hudson- Domestic",
        price: 16,
        diff: -5,
        notes: "NA",
        data: [16, 16],
      },
    ],
  },
  {
    title: "Chicken Sandwich",
    brand: "ALLPRESS CAFE",
    pricerank: "6 / 9",
    price: 14.0,
    avg: 12.23,
    diff: 1.77,
    diffper: 12.64,
    terminal: "Intl Landside",
    id: 15,
    type: "Food - cabinet",
    details: [
      {
        title: "Chicken Sandwich",
        brand: "Esquires, Westfield Manukau",
        price: 7.2,
        diff: 6.8,
        notes: "NA",
        data: [7.2, 7.2],
      },
      {
        title: "Chicken Sandwich",
        brand: "Muffin Break Manukau",
        price: 7.5,
        diff: 6.5,
        notes: "NA",
        data: [9.9, 7.5],
      },
      {
        title: "Chicken Sandwich",
        brand: "Gloria Jeans, Manukau",
        price: 8.5,
        diff: 5.5,
        notes: "NA",
        data: [8.5, 8.5],
      },
      {
        title: "Chicken Sandwich",
        brand: "Columbus Coffee, Sylvia Park",
        price: 12.5,
        diff: 1.5,
        notes: "NA",
        data: [14.5, 12.5],
      },
      {
        title: "Chicken Sandwich",
        brand: "Jamaica Blue, Leonard Issit Drive",
        price: 13.9,
        diff: 0.1,
        notes: "NA",
        data: [13.9, 13.9],
      },
      {
        title: "Chicken Sandwich",
        brand: "Allpress Cafe",
        price: 14.0,
        diff: 0,
        notes: "NA",
        data: [14, 14],
      },
      {
        title: "Chicken Sandwich",
        brand: "Kawau Kitchen, Leonard Issit Drive",
        price: 14.5,
        diff: 0,
        notes: "NA",
        data: [11.5, 14.5],
      },
      {
        title: "Chicken Sandwich",
        brand: "Aroha Café- Airside",
        price: 16.0,
        diff: -2.0,
        notes: "NA",
        data: [16, 16],
      },
      {
        title: "Chicken Sandwich",
        brand: "Hudson",
        price: 16.0,
        diff: -2.0,
        notes: "NA",
        data: [16, 16],
      },
    ],
  },
  {
    title: "Cheese & Tomato Croissant",
    brand: "ALLPRESS CAFE",
    pricerank: "4 / 6",
    price: 13.0,
    avg: 11.92,
    diff: 1.08,
    diffper: 8.3,
    terminal: "Intl Landside",
    id: 16,
    type: "Food - cabinet",
    details: [
      {
        title: "Cheese & Tomato Croissant",
        brand: "Muffin Break Manukau",
        price: 8.9,
        diff: 4.1,
        notes: "NA",
        data: [8.9, 8.9],
      },
      {
        title: "Cheese & Tomato Croissant",
        brand: "Gloria Jeans, Manukau",
        price: 10.9,
        diff: 2.1,
        notes: "NA",
        data: [10.9, 10.9],
      },
      {
        title: "Cheese & Tomato Croissant",
        brand: "Jamaica Blue, Leonard Issit Drive",
        price: 10.9,
        diff: 2.1,
        notes: "NA",
        data: [10.9, 10.9],
      },
      {
        title: "Cheese & Tomato Croissant",
        brand: "Allpress cafe",
        price: 13.0,
        diff: 0,
        notes: "NA",
        data: [13, 13],
      },
      {
        title: "Cheese & Tomato Croissant",
        brand: "Esquires, Westfield Manukau",
        price: 13.8,
        diff: -0.8,
        notes: "NA",
        data: [13.8, 13.8],
      },
      {
        title: "Cheese & Tomato Croissant",
        brand: "Aroha Café- Airside",
        price: 14.0,
        diff: -1.0,
        notes: "NA",
        data: [14, 14],
      },
    ],
  },
  {
    title: "Flat white - medium",
    brand: "ALLPRESS CAFE",
    pricerank: "1 / 8",
    price: 5.9,
    avg: 6.2,
    diff: -0.3,
    diffper: -5,
    terminal: "Intl Landside",
    id: 17,
    type: "Food - cabinet",
    details: [
      {
        title: "Flat white - medium",
        brand: "Allpress Cafe",
        price: 5.9,
        diff: 0,
        notes: "NA",
        data: [5.9, 5.9],
      },
      {
        title: "Flat white - medium",
        brand: "Aroha Café- Airside",
        price: 6,
        diff: -0.1,
        notes: "NA",
        data: [6, 6],
      },
      {
        title: "Flat white - medium",
        brand: "Kawau Kitchen, Leonard Issit Drive",
        price: 6,
        diff: -0.1,
        notes: "NA",
        data: [6, 6],
      },
      {
        title: "Flat white - medium",
        brand: "Hudson- Domestic",
        price: 6,
        diff: -0.1,
        notes: "NA",
        data: [6, 6],
      },
      {
        title: "Flat white - medium",
        brand: "Muffin Break Manukau",
        price: 6.3,
        diff: -0.4,
        notes: "NA",
        data: [6.3, 6.3],
      },
      {
        title: "Flat white - medium",
        brand: "Gloria Jeans, Manukau",
        price: 6.3,
        diff: -0.4,
        notes: "NA",
        data: [6.3, 6.3],
      },
      {
        title: "Flat white - medium",
        brand: "Esquires, Westfield Manukau",
        price: 6.3,
        diff: -0.4,
        notes: "NA",
        data: [6.3, 6.3],
      },
      {
        title: "Flat white - medium",
        brand: "Jamaica Blue, Leonard Issit Drive",
        price: 6.3,
        diff: -0.4,
        notes: "NA",
        data: [6.3, 6.3],
      },
    ],
  },
];

export const dfProductData = [
  {
    src: "/midori.jpeg",
    title: "Midori Liqueur 1L",
    brand: "MIDORI",
    pricerange: "36.66 - 59.99",
    pricerank: "1 / 9",
    id: 0,
    location: "AUCKLAND",
    category: "liquor",
    details: [
      {
        location: "AUCKLAND",
        brand: "AUCKLAND DUTYFREE",
        pricerange: "36.66 - 50.00",
        promos: [
          {
            promo: "BUY 3 FOR 110$",
            price: "36.66",
          },
          {
            promo: "BUY 2 FOR 79$",
            price: "34.50",
          },
          {
            promo: "BUY 3 FOR 110$",
            price: "50.00",
          },
        ],
        qty: 1000,
        unit: "ml",
        pricerangeperunit: "0.036 - 0.050",
        tag: "DUTY-FREE",
        data: [47.5, 46.5, 47.0, 46.2, 46.0, 45.35, 47.0],
      },
      {
        location: "QUEENSTOWN",
        brand: "AELIA",
        pricerange: "36.66 - 50.00",
        promos: [
          {
            promo: "BUY 3 FOR 110$",
            price: "36.66",
          },
          {
            promo: "BUY 2 FOR 79$",
            price: "34.50",
          },
          {
            promo: "BUY 3 FOR 110$",
            price: "50.00",
          },
        ],
        qty: 1000,
        unit: "ml",
        pricerangeperunit: "0.036 - 0.050",
        tag: "DUTY-FREE",
        data: [47.5, 46.5, 47.0, 46.2, 46.0, 45.35, 47.0],
      },
      {
        location: "CHRISTCHURCH",
        brand: "AELIA",
        pricerange: "36.66 - 50.00",
        promos: [
          {
            promo: "BUY 3 FOR 110$",
            price: "36.66",
          },
          {
            promo: "BUY 2 FOR 79$",
            price: "34.50",
          },
          {
            promo: "BUY 3 FOR 110$",
            price: "50.00",
          },
        ],
        qty: 1000,
        unit: "ml",
        pricerangeperunit: "0.036 - 0.050",
        tag: "DUTY-FREE",
        data: [47.5, 46.5, 47.0, 46.2, 46.0, 45.35, 47.0],
      },
      {
        location: "BRISBANE",
        brand: "LOTTE",
        pricerange: "42.25 - 55.11",
        promos: [
          {
            promo: "BUY 3 FOR 126.78$",
            price: "42.25",
          },
          {
            promo: "BUY 2 FOR 87.09$",
            price: "34.50",
          },
          {
            promo: "BUY 3 FOR 126.78$",
            price: "55.11",
          },
        ],
        qty: 1000,
        unit: "ml",
        pricerangeperunit: "0.042 - 0.055",
        tag: "DUTY-FREE",
        data: [32.66, 31.0, 33.0, 34.0, 33.0, 31.35, 31.66],
      },
      {
        location: "MELBOURNE",
        brand: "LOTTE",
        pricerange: "42.25 - 55.11",
        promos: [
          {
            promo: "BUY 3 FOR 126.78$",
            price: "42.25",
          },
          {
            promo: "BUY 2 FOR 87.09$",
            price: "34.50",
          },
          {
            promo: "BUY 3 FOR 126.78$",
            price: "55.11",
          },
        ],
        qty: 1000,
        unit: "ml",
        pricerangeperunit: "0.042 - 0.055",
        tag: "DUTY-FREE",
        data: [32.66, 31.0, 33.0, 34.0, 33.0, 31.35, 31.66],
      },
      {
        location: "AUCKLAND",
        brand: "BIG BARREL",
        pricerange: "49.99",
        promos: [],
        qty: 1000,
        unit: "ml",
        pricerangeperunit: "0.049",
        tag: "DOMESTIC",
        data: [31.66, 32.0, 34.0, 33.0, 33.0, 32.35, 31.66],
      },
      {
        location: "AUCKLAND",
        brand: "WHISKY AND MORE",
        pricerange: "52.00",
        promos: [],
        qty: 1000,
        unit: "ml",
        pricerangeperunit: "0.052",
        tag: "DOMESTIC",
        data: [31.66, 32.0, 34.0, 33.0, 33.0, 32.35, 31.66],
      },
      {
        location: "SYDNEY",
        brand: "HEINEMANN",
        pricerange: "55.12",
        promos: [],
        qty: 1000,
        unit: "ml",
        pricerangeperunit: "0.055",
        tag: "DUTY-FREE",
        data: [32.66, 31.0, 33.0, 34.0, 33.0, 31.35, 31.66],
      },
      {
        location: "AUCKLAND",
        brand: "NZ LIQUOR",
        pricerange: "59.99",
        promos: [],
        qty: 1000,
        unit: "ml",
        pricerangeperunit: "0.059",
        tag: "DOMESTIC",
        data: [31.66, 32.0, 34.0, 33.0, 33.0, 32.35, 31.66],
      },
    ],
  },
  {
    src: "/red-label.jpg",
    title: "Johnnie Walker Red Label Blended Scotch Whisky",
    brand: "JOHNNIE WALKER",
    pricerange: "31.66 - 58.39",
    pricerank: "1 / 8",
    id: 0,
    location: "AUCKLAND",
    category: "liquor",
    details: [
      {
        location: "AUCKLAND",
        brand: "AUCKLAND DUTYFREE",
        pricerange: "31.66 - 52.00",
        promos: [
          {
            promo: "BUY 3 FOR 95$",
            price: "31.66",
          },
          {
            promo: "BUY 2 FOR 69$",
            price: "34.50",
          },
          {
            promo: "BUY 3 FOR 95$",
            price: "52.00",
          },
        ],
        qty: 1125,
        unit: "ml",
        pricerangeperunit: "0.028 - 0.046",
        tag: "DUTY-FREE",
        data: [47.5, 46.5, 47.0, 46.2, 46.0, 45.35, 47.0],
      },
      {
        location: "CHRISTCHURCH",
        brand: "AELIA",
        pricerange: "31.66 - 52.00",
        promos: [
          {
            promo: "BUY 3 FOR 95$",
            price: "31.66",
          },
          {
            promo: "BUY 2 FOR 69$",
            price: "34.50",
          },
          {
            promo: "BUY 3 FOR 95$",
            price: "52.00",
          },
        ],
        qty: 1125,
        unit: "ml",
        pricerangeperunit: "0.028 - 0.046",
        tag: "DUTY-FREE",
        data: [47.5, 46.5, 47.0, 46.2, 46.0, 45.35, 47.0],
      },
      {
        location: "QUEENSTOWN",
        brand: "AELIA",
        pricerange: "31.66 - 52.00",
        promos: [
          {
            promo: "BUY 3 FOR 95$",
            price: "31.66",
          },
          {
            promo: "BUY 2 FOR 69$",
            price: "34.50",
          },
          {
            promo: "BUY 3 FOR 95$",
            price: "52.00",
          },
        ],
        qty: 1125,
        unit: "ml",
        pricerangeperunit: "0.028 - 0.046",
        tag: "DUTY-FREE",
        data: [47.5, 46.5, 47.0, 46.2, 46.0, 45.35, 47.0],
      },
      {
        location: "BRISBANE",
        brand: "LOTTE",
        pricerange: "42.24 - 58.39",
        promos: [
          {
            promo: "BUY 3 FOR 126.72$",
            price: "42.24",
          },
          {
            promo: "BUY 2 FOR 87.05$",
            price: "43.52",
          },
          {
            promo: "BUY 3 FOR 126.72$",
            price: "58.39",
          },
        ],
        qty: 1125,
        unit: "ml",
        pricerangeperunit: "0.037 - 0.051",
        tag: "DUTY-FREE",
        data: [47.5, 46.5, 47.0, 46.2, 46.0, 45.35, 47.0],
      },
      {
        location: "MELBOURNE",
        brand: "LOTTE",
        pricerange: "42.24 - 58.39",
        promos: [
          {
            promo: "BUY 3 FOR 126.72$",
            price: "42.24",
          },
          {
            promo: "BUY 2 FOR 87.05$",
            price: "43.52",
          },
          {
            promo: "BUY 3 FOR 126.72$",
            price: "58.39",
          },
        ],
        qty: 1125,
        unit: "ml",
        pricerangeperunit: "0.037 - 0.051",
        tag: "DUTY-FREE",
        data: [47.5, 46.5, 47.0, 46.2, 46.0, 45.35, 47.0],
      },
      {
        location: "AUCKLAND",
        brand: "BIG BARREL",
        pricerange: "54.99",
        promos: [],
        qty: 1000,
        unit: "ml",
        pricerangeperunit: "0.054",
        tag: "DOMESTIC",
        data: [47.5, 46.5, 47.0, 46.2, 46.0, 45.35, 47.0],
      },
      {
        location: "AUCKLAND",
        brand: "WHISKY AND MORE",
        pricerange: "54.00",
        promos: [],
        qty: 1000,
        unit: "ml",
        pricerangeperunit: "0.054",
        tag: "DOMESTIC",
        data: [47.5, 46.5, 47.0, 46.2, 46.0, 45.35, 47.0],
      },
      {
        location: "AUCKLAND",
        brand: "NZ LIQUOR",
        pricerange: "59.99",
        promos: [],
        qty: 1000,
        unit: "ml",
        pricerangeperunit: "0.059",
        tag: "DOMESTIC",
        data: [47.5, 46.5, 47.0, 46.2, 46.0, 45.35, 47.0],
      },
    ],
  },
  {
    src: "/Clinique-2.jpg",
    title: "Clinique Even Better Makeup SPF 15 Foundation",
    brand: "CLINIQUE",
    pricerange: "49.63 - 75.00",
    pricerank: "3 / 7",
    id: 7,
    location: "AUCKLAND",
    category: "beauty",
    details: [
      {
        location: "BRISBANE",
        brand: "LOTTE",
        pricerange: "49.63",
        promos: [],
        qty: "",
        unit: "",
        pricerangeperunit: "",
        tag: "DUTY-FREE",
        data: [5.5, 6.5, 7.0, 7.0, 6.0, 5.35, 6.9],
      },
      {
        location: "SYDNEY",
        brand: "HEINEMANN",
        pricerange: "57.35",
        promos: [],
        qty: "",
        unit: "",
        pricerangeperunit: "",
        tag: "DUTY-FREE",
        data: [5.5, 6.5, 7.0, 7.0, 6.0, 5.35, 6.9],
      },
      {
        location: "AUCKLAND",
        brand: "AUCKLAND DUTYFREE",
        pricerange: "60.00",
        promos: [],
        qty: "",
        unit: "",
        pricerangeperunit: "",
        tag: "DUTY-FREE",
        data: [5.5, 6.5, 7.0, 7.0, 6.0, 5.35, 6.9],
      },
      {
        location: "CHRISTCHURCH",
        brand: "AELIA",
        pricerange: "60.00",
        promos: [],
        qty: "",
        unit: "",
        pricerangeperunit: "",
        tag: "DUTY-FREE",
        data: [5.5, 6.5, 7.0, 7.0, 6.0, 5.35, 6.9],
      },

      {
        location: "AUCKLAND",
        brand: "SEPHORA",
        pricerange: "75.00",
        promos: [],
        qty: "",
        unit: "",
        pricerangeperunit: "",
        tag: "DOMESTIC",
        data: [5.5, 6.5, 7.0, 7.0, 6.0, 5.35, 6.9],
      },
      {
        location: "AUCKLAND",
        brand: "MECCA",
        pricerange: "75.00",
        promos: [],
        qty: "",
        unit: "",
        pricerangeperunit: "",
        tag: "DOMESTIC",
        data: [5.5, 6.5, 7.0, 7.0, 6.0, 5.35, 6.9],
      },
      {
        location: "AUCKLAND",
        brand: "FARMERS",
        pricerange: "75.00",
        promos: [],
        qty: "",
        unit: "",
        pricerangeperunit: "",
        tag: "DOMESTIC",
        data: [5.5, 6.5, 7.0, 7.0, 6.0, 5.35, 6.9],
      },
    ],
  },

  {
    src: "/calvin-klein.jpg",
    title: "Calvin Klein Defy Eau De Toilette",
    brand: "CALVIN KLEIN",
    pricerange: "54.99 - 120.00",
    pricerank: "5 / 7",
    id: 8,
    location: "AUCKLAND",
    category: "beauty",
    details: [
      {
        location: "AUCKLAND",
        brand: "CHEMIST WAREHOUSE",
        pricerange: "54.99",
        promos: [],
        qty: "100",
        unit: "ml",
        pricerangeperunit: "0.549",
        tag: "DOMESTIC",
        data: [5.5, 6.5, 7.0, 7.0, 6.0, 5.35, 6.9],
      },
      {
        location: "SYDNEY",
        brand: "HEINEMANN",
        pricerange: "97.05",
        promos: [],
        qty: "100",
        unit: "ml",
        pricerangeperunit: "0.97",
        tag: "DUTY-FREE",
        data: [5.5, 6.5, 7.0, 7.0, 6.0, 5.35, 6.9],
      },
      {
        location: "BRISBANE",
        brand: "LOTTE",
        pricerange: "98.26",
        promos: [],
        qty: "100",
        unit: "ml",
        pricerangeperunit: "0.98",
        tag: "DUTY-FREE",
        data: [5.5, 6.5, 7.0, 7.0, 6.0, 5.35, 6.9],
      },
      {
        location: "MELBOURNE",
        brand: "LOTTE",
        pricerange: "98.26",
        promos: [],
        qty: "100",
        unit: "ml",
        pricerangeperunit: "0.891",
        tag: "DUTY-FREE",
        data: [5.5, 6.5, 7.0, 7.0, 6.0, 5.35, 6.9],
      },
      {
        location: "AUCKLAND",
        brand: "AUCKLAND DUTYFREE",
        pricerange: "106.00",
        promos: [],
        qty: "100",
        unit: "ml",
        pricerangeperunit: "1.06",
        tag: "DUTY-FREE",
        data: [5.5, 6.5, 7.0, 7.0, 6.0, 5.35, 6.9],
      },
      {
        location: "CHRISTCHURCH",
        brand: "AELIA",
        pricerange: "106.00",
        promos: [],
        qty: "100",
        unit: "ml",
        pricerangeperunit: "1.06",
        tag: "DUTY-FREE",
        data: [5.5, 6.5, 7.0, 7.0, 6.0, 5.35, 6.9],
      },

      {
        location: "AUCKLAND",
        brand: "FARMERS",
        pricerange: "120.00",
        promos: [],
        qty: "100",
        unit: "ml",
        pricerangeperunit: "1.20",
        tag: "DOMESTIC",
        data: [5.5, 6.5, 7.0, 7.0, 6.0, 5.35, 6.9],
      },
    ],
  },

  {
    src: "/black-label.jpg",
    title: "Johnnie Walker Double Black Blended Scotch Whisky 1L",
    brand: "JOHNNIE WALKER",
    pricerange: "71.66- 101.44",
    pricerank: "1 / 6",
    id: 0,
    location: "AUCKLAND",
    category: "liquor",
    details: [
      {
        location: "AUCKLAND",
        brand: "AUCKLAND DUTYFREE",
        pricerange: "71.66 - 98.00",
        promos: [
          {
            promo: "BUY 3 FOR 215$",
            price: "71.66",
          },
          {
            promo: "BUY 2 FOR 159$",
            price: "34.50",
          },
          {
            promo: "BUY 3 FOR 215$",
            price: "98.00",
          },
        ],
        qty: 1000,
        unit: "ml",
        pricerangeperunit: "0.071 - 0.098",
        tag: "DUTY-FREE",
        data: [47.5, 46.5, 47.0, 46.2, 46.0, 45.35, 47.0],
      },
      {
        location: "QUEENSTOWN",
        brand: "AELIA",
        pricerange: "71.66 - 98.00",
        promos: [
          {
            promo: "BUY 3 FOR 215$",
            price: "71.66",
          },
          {
            promo: "BUY 2 FOR 159$",
            price: "34.50",
          },
          {
            promo: "BUY 3 FOR 215$",
            price: "98.00",
          },
        ],
        qty: 1000,
        unit: "ml",
        pricerangeperunit: "0.071 - 0.098",
        tag: "DUTY-FREE",
        data: [47.5, 46.5, 47.0, 46.2, 46.0, 45.35, 47.0],
      },

      {
        location: "AUCKLAND",
        brand: "BIG BARREL",
        pricerange: "89.99",
        promos: [],
        qty: 1000,
        unit: "ml",
        pricerangeperunit: "0.089",
        tag: "DOMESTIC",
        data: [31.66, 32.0, 34.0, 33.0, 33.0, 32.35, 31.66],
      },
      {
        location: "AUCKLAND",
        brand: "WHISKY AND MORE",
        pricerange: "91.00",
        promos: [],
        qty: 1000,
        unit: "ml",
        pricerangeperunit: "0.091",
        tag: "DOMESTIC",
        data: [31.66, 32.0, 34.0, 33.0, 33.0, 32.35, 31.66],
      },
      {
        location: "BRISBANE",
        brand: "LOTTE",
        pricerange: "101.44",
        promos: [],
        qty: 1000,
        unit: "ml",
        pricerangeperunit: "0.101",
        tag: "DUTY-FREE",
        data: [32.66, 31.0, 33.0, 34.0, 33.0, 31.35, 31.66],
      },

      {
        location: "MELBOURNE",
        brand: "LOTTE",
        pricerange: "101.44",
        promos: [],
        qty: 1000,
        unit: "ml",
        pricerangeperunit: "0.101",
        tag: "DUTY-FREE",
        data: [32.66, 31.0, 33.0, 34.0, 33.0, 31.35, 31.66],
      },
    ],
  },

  {
    src: "/bailey.jpeg",
    title: "Baileys Tiramisu Liqueur",
    brand: "BAILEYS",
    pricerange: "31.66 - 49.99",
    pricerank: "1 / 5",
    id: 0,
    location: "AUCKLAND",
    category: "liquor",
    details: [
      {
        location: "AUCKLAND",
        brand: "AUCKLAND DUTYFREE",
        pricerange: "31.66 - 40.00",
        promos: [
          {
            promo: "BUY 3 FOR 95$",
            price: "31.66",
          },
          {
            promo: "BUY 2 FOR 69$",
            price: "34.50",
          },
          {
            promo: "BUY 3 FOR 95$",
            price: "40.00",
          },
        ],
        qty: 700,
        unit: "ml",
        pricerangeperunit: "0.045 - 0.057",
        tag: "DUTY-FREE",
        data: [47.5, 46.5, 47.0, 46.2, 46.0, 45.35, 47.0],
      },
      {
        location: "QUEENSTOWN",
        brand: "AELIA",
        pricerange: "31.66 - 40.00",
        promos: [
          {
            promo: "BUY 3 FOR 95$",
            price: "31.66",
          },
          {
            promo: "BUY 2 FOR 69$",
            price: "34.50",
          },
          {
            promo: "BUY 3 FOR 95$",
            price: "40.00",
          },
        ],
        qty: 700,
        unit: "ml",
        pricerangeperunit: "0.045 - 0.057",
        tag: "DUTY-FREE",
        data: [47.5, 46.5, 47.0, 46.2, 46.0, 45.35, 47.0],
      },

      {
        location: "AUCKLAND",
        brand: "WHISKY AND MORE",
        pricerange: "36.00",
        promos: [],
        qty: 700,
        unit: "ml",
        pricerangeperunit: "0.051",
        tag: "DOMESTIC",
        data: [32.66, 31.0, 33.0, 34.0, 33.0, 31.35, 31.66],
      },

      {
        location: "SYDNEY",
        brand: "HEINEMANN",
        pricerange: "45.20",
        promos: [],
        qty: 700,
        unit: "ml",
        pricerangeperunit: "0.064",
        tag: "DUTY-FREE",
        data: [46.0, 46.5, 47.0, 47.0, 46.0, 45.35, 44.92],
      },
      {
        location: "AUCKLAND",
        brand: "NZ LIQUOR",
        pricerange: "49.99",
        promos: [],
        qty: 700,
        unit: "ml",
        pricerangeperunit: "0.071",
        tag: "DOMESTIC",
        data: [31.66, 32.0, 34.0, 33.0, 33.0, 32.35, 31.66],
      },
    ],
  },

  {
    src: "/Clinque.jpg",
    title: "Clinique 7 Day Scrub Cream Rinse-Off Formula",
    brand: "CLINIQUE",
    pricerange: "47.64 - 74.00",
    pricerank: "3 / 5",
    id: 5,
    location: "AUCKLAND",
    category: "beauty",
    details: [
      {
        location: "BRISBANE",
        brand: "LOTTE",
        pricerange: "47.64",
        promos: [],
        qty: "100",
        unit: "ml",
        pricerangeperunit: "0.476",
        tag: "DUTY-FREE",
        data: [5.5, 6.5, 7.0, 7.0, 6.0, 5.35, 6.9],
      },
      {
        location: "SYDNEY",
        brand: "HEINEMANN",
        pricerange: "51.83",
        promos: [],
        qty: "100",
        unit: "ml",
        pricerangeperunit: "0.518",
        tag: "DUTY-FREE",
        data: [5.5, 6.5, 7.0, 7.0, 6.0, 5.35, 6.9],
      },
      {
        location: "AUCKLAND",
        brand: "AUCKLAND DUTYFREE",
        pricerange: "59.00",
        promos: [],
        qty: "100",
        unit: "ml",
        pricerangeperunit: "0.59",
        tag: "DUTY-FREE",
        data: [5.5, 6.5, 7.0, 7.0, 6.0, 5.35, 6.9],
      },
      {
        location: "CHRISTCHURCH",
        brand: "AELIA",
        pricerange: "59.00",
        promos: [],
        qty: "100",
        unit: "ml",
        pricerangeperunit: "0.59",
        tag: "DUTY-FREE",
        data: [5.5, 6.5, 7.0, 7.0, 6.0, 5.35, 6.9],
      },

      {
        location: "AUCKLAND",
        brand: "FARMERS",
        pricerange: "74.00",
        promos: [],
        qty: "100",
        unit: "ml",
        pricerangeperunit: "0.74",
        tag: "DOMESTIC",
        data: [5.5, 6.5, 7.0, 7.0, 6.0, 5.35, 6.9],
      },
    ],
  },
  {
    src: "/jagermeister.jpg",
    title: "Jagermeister Liqueur",
    brand: "JAGERMEISTER",
    pricerange: "52.00 - 69.99",
    pricerank: "1 / 5",
    id: 4,
    location: "AUCKLAND",
    category: "liquor",
    details: [
      {
        location: "AUCKLAND",
        brand: "AUCKLAND DUTYFREE",
        pricerange: "52.00",
        promos: [],
        qty: 1000,
        unit: "ml",
        pricerangeperunit: "0.052",
        tag: "DUTY-FREE",
        data: [5.5, 6.5, 7.0, 7.0, 6.0, 5.35, 6.9],
      },
      {
        location: "CHRISTCHURCH",
        brand: "AELIA",
        pricerange: "52.00",
        promos: [],
        qty: 1000,
        unit: "ml",
        pricerangeperunit: "0.052",
        tag: "DUTY-FREE",
        data: [5.5, 6.5, 7.0, 7.0, 6.0, 5.35, 6.9],
      },
      {
        location: "SYDNEY",
        brand: "HEINEMANN",
        pricerange: "55.14",
        promos: [],
        qty: 1000,
        unit: "ml",
        pricerangeperunit: "0.055",
        tag: "DUTY-FREE",
        data: [5.5, 6.5, 7.0, 7.0, 6.0, 5.35, 6.9],
      },

      {
        location: "AUCKLAND",
        brand: "BIG BARREL",
        pricerange: "64.99",
        promos: [],
        qty: 1000,
        unit: "ml",
        pricerangeperunit: "0.064",
        tag: "DOMESTIC",
        data: [5.5, 6.5, 7.0, 7.0, 6.0, 5.35, 6.9],
      },
      {
        location: "AUCKLAND",
        brand: "NZ LIQUOR",
        pricerange: "69.99",
        promos: [],
        qty: 1000,
        unit: "ml",
        pricerangeperunit: "0.069",
        tag: "DOMESTIC",
        data: [5.5, 6.5, 7.0, 7.0, 6.0, 5.35, 6.9],
      },
    ],
  },

  {
    src: "/baileys-expresso-creme.jpg",
    title: "Baileys Espresso Creme Liqueur",
    brand: "BAILEYS",
    pricerange: "31.66 - 49.63",
    pricerank: "1 / 4",
    id: 0,
    location: "AUCKLAND",
    category: "liquor",
    details: [
      {
        location: "AUCKLAND",
        brand: "AUCKLAND DUTYFREE",
        pricerange: "31.66 - 47.00",
        promos: [
          {
            promo: "BUY 3 FOR 95$",
            price: "31.66",
          },
          {
            promo: "BUY 2 FOR 69$",
            price: "34.50",
          },
          {
            promo: "BUY 3 FOR 95$",
            price: "40.00",
          },
        ],
        qty: 1000,
        unit: "ml",
        pricerangeperunit: "0.031 - 0.047",
        tag: "DUTY-FREE",
        data: [31.66, 32.0, 34.0, 33.0, 33.0, 32.35, 31.66],
      },
      {
        location: "CHRISTCHURCH",
        brand: "AELIA",
        pricerange: "31.66 - 47.00",
        promos: [
          {
            promo: "BUY 3 FOR 95$",
            price: "31.66",
          },
          {
            promo: "BUY 2 FOR 69$",
            price: "34.50",
          },
          {
            promo: "BUY 3 FOR 95$",
            price: "40.00",
          },
        ],
        qty: 1000,
        unit: "ml",
        pricerangeperunit: "0.031 - 0.047",
        tag: "DUTY-FREE",
        data: [32.66, 31.0, 33.0, 34.0, 33.0, 31.35, 31.66],
      },
      // {
      //   location: "AUCKLAND",
      //   brand: "WHISKY AND MORE",
      //   pricerange: "36.00",
      //   promos: [],
      //   qty: 700,
      //   unit: "ml",
      //   pricerangeperunit: "0.051",
      //   tag: "DOMESTIC",
      //   data: [47.5, 46.5, 47.0, 46.2, 46.0, 45.35, 47.0],
      // },
      {
        location: "BRISBANE",
        brand: "LOTTE",
        pricerange: "47.41",
        promos: [],
        qty: 1000,
        unit: "ml",
        pricerangeperunit: "0.047",
        tag: "DUTY-FREE",
        data: [43.0, 43.5, 44.0, 43.5, 42.0, 41.35, 41.62],
      },
      {
        location: "SYDNEY",
        brand: "HEINEMANN",
        pricerange: "49.63",
        promos: [],
        qty: 1000,
        unit: "ml",
        pricerangeperunit: "0.049",
        tag: "DUTY-FREE",
        data: [46.0, 46.5, 47.0, 47.0, 46.0, 45.35, 44.92],
      },
    ],
  },

  {
    src: "/Cointear liqueur.jpg",
    title: "Cointreau Liqueur",
    brand: "COINTREAU",
    pricerange: "50.00 - 89.99",
    pricerank: "1 / 4",
    id: 1,
    location: "AUCKLAND",
    category: "liquor",
    details: [
      {
        location: "AUCKLAND",
        brand: "AUCKLAND DUTYFREE",
        pricerange: "50.00 - 70.00",
        promos: [],
        qty: 1000,
        unit: "ml",
        pricerangeperunit: "0.050 - 0.070",
        tag: "DUTY-FREE",
        data: [5.5, 6.5, 7.0, 7.0, 6.0, 5.35, 6.9],
      },
      {
        location: "CHRISTCHURCH",
        brand: "AELIA",
        pricerange: "50.00 - 70.00",
        promos: [],
        qty: 1000,
        unit: "ml",
        pricerangeperunit: "0.050 - 0.070",
        tag: "DUTY-FREE",
        data: [5.5, 6.5, 7.0, 7.0, 6.0, 5.35, 6.9],
      },
      {
        location: "BRISBANE",
        brand: "LOTTE",
        pricerange: "51.46 - 77.19",
        promos: [],
        qty: 1000,
        unit: "ml",
        pricerangeperunit: "0.051 - 0.077",
        tag: "DUTY-FREE",
        data: [5.5, 6.5, 7.0, 7.0, 6.0, 5.35, 6.9],
      },
      {
        location: "AUCKLAND",
        brand: "BIG BARREL",
        pricerange: "89.99",
        promos: [],
        qty: 1000,
        unit: "ml",
        pricerangeperunit: "0.089",
        tag: "DOMESTIC",
        data: [5.5, 6.5, 7.0, 7.0, 6.0, 5.35, 6.9],
      },
    ],
  },

  {
    src: "/kahlua.jpg",
    title: "Kahlua Liqueur Original",
    brand: "KAHLUA",
    pricerange: "31.66 - 44.00",
    pricerank: "1 / 3",
    id: 2,
    location: "AUCKLAND",
    category: "liquor",
    details: [
      {
        location: "AUCKLAND",
        brand: "AUCKLAND DUTYFREE",
        pricerange: "31.66 - 44.00",
        promos: [],
        qty: 1000,
        unit: "ml",
        pricerangeperunit: "0.031 - 0.044",
        tag: "DUTY-FREE",
        data: [5.5, 6.5, 7.0, 7.0, 6.0, 5.35, 6.9],
      },
      {
        location: "QUEENSTOWN",
        brand: "AELIA",
        pricerange: "31.66 - 44.00",
        promos: [],
        qty: 1000,
        unit: "ml",
        pricerangeperunit: "0.031 - 0.044",
        tag: "DUTY-FREE",
        data: [5.5, 6.5, 7.0, 7.0, 6.0, 5.35, 6.9],
      },
      {
        location: "CHRISTCHURCH",
        brand: "AELIA",
        pricerange: "31.66 - 44.00",
        promos: [],
        qty: 1000,
        unit: "ml",
        pricerangeperunit: "0.031 - 0.044",
        tag: "DUTY-FREE",
        data: [5.5, 6.5, 7.0, 7.0, 6.0, 5.35, 6.9],
      },
    ],
  },

  {
    src: "/wild-ferns.jpg",
    title: "Wild Ferns Lanolin Duty Free Gift Box",
    brand: "WILD FERNS",
    pricerange: "94.99",
    pricerank: "1 / 3",
    id: 6,
    location: "AUCKLAND",
    category: "beauty",
    details: [
      {
        location: "AUCKLAND",
        brand: "AUCKLAND DUTYFREE",
        pricerange: "94.99",
        promos: [],
        qty: "",
        unit: "",
        pricerangeperunit: "",
        tag: "DUTY-FREE",
        data: [5.5, 6.5, 7.0, 7.0, 6.0, 5.35, 6.9],
      },
      {
        location: "CHRISTCHURCH",
        brand: "AELIA",
        pricerange: "94.99",
        promos: [],
        qty: "",
        unit: "",
        pricerangeperunit: "",
        tag: "DUTY-FREE",
        data: [5.5, 6.5, 7.0, 7.0, 6.0, 5.35, 6.9],
      },
      {
        location: "QUEENSTOWN",
        brand: "AELIA",
        pricerange: "94.99",
        promos: [],
        qty: "",
        unit: "",
        pricerangeperunit: "",
        tag: "DUTY-FREE",
        data: [5.5, 6.5, 7.0, 7.0, 6.0, 5.35, 6.9],
      },
    ],
  },

  {
    src: "/luminous.jpg",
    title: "LUMINOUS SILK FOUNDATION",
    brand: "GIORGIO ARMANI",
    pricerange: "83.38 - 95.00",
    pricerank: "3 / 3",
    id: 9,
    location: "AUCKLAND",
    category: "beauty",
    details: [
      {
        location: "BRISBANE",
        brand: "LOTTE",
        pricerange: "83.38",
        promos: [],
        qty: "",
        unit: "",
        pricerangeperunit: "",
        tag: "DUTY-FREE",
        data: [5.5, 6.5, 7.0, 7.0, 6.0, 5.35, 6.9],
      },
      {
        location: "MELBOURNE",
        brand: "LOTTE",
        pricerange: "83.38",
        promos: [],
        qty: "",
        unit: "",
        pricerangeperunit: "",
        tag: "DUTY-FREE",
        data: [5.5, 6.5, 7.0, 7.0, 6.0, 5.35, 6.9],
      },
      {
        location: "AUCKLAND",
        brand: "AUCKLAND DUTYFREE",
        pricerange: "95",
        promos: [],
        qty: "",
        unit: "",
        pricerangeperunit: "",
        tag: "DUTY-FREE",
        data: [5.5, 6.5, 7.0, 7.0, 6.0, 5.35, 6.9],
      },
    ],
  },

  {
    src: "/somrus.jpg",
    title: "Somrus Coffee Cream Liqueur",
    brand: "SOMRUS",
    pricerange: "36.66 - 69.00",
    pricerank: "1 / 2",
    id: 4,
    location: "AUCKLAND",
    category: "liquor",
    details: [
      {
        location: "AUCKLAND",
        brand: "AUCKLAND DUTYFREE",
        pricerange: "36.66 - 69.00",
        promos: [],
        qty: 1000,
        unit: "ml",
        pricerangeperunit: "0.036 - 0.069",
        tag: "DUTY-FREE",
        data: [5.5, 6.5, 7.0, 7.0, 6.0, 5.35, 6.9],
      },
      {
        location: "CHRISTCHURCH",
        brand: "AELIA",
        pricerange: "36.66 - 69.00",
        promos: [],
        qty: 1000,
        unit: "ml",
        pricerangeperunit: "0.036 - 0.069",
        tag: "DUTY-FREE",
        data: [5.5, 6.5, 7.0, 7.0, 6.0, 5.35, 6.9],
      },
    ],
  },
];

export const colorSeq = [
  "red",
  "orange",
  "green",
  "blue",
  "black",
  "#FF33F5",
  "#FF5733",
  "rebeccapurple",
  "#33FF57",
  "#5733FF",
  "#33FFF5",
];

export const summary_notes = `
 Format this JSON data into a below expected output JSON adding interpretation. (please dont return json with no post or pre text else it will throw error in frontend)

   Expected Output: (This data is just dummy to show the format, please do not hallucinate)
    {
      "location_category_level_price_trends": [
        { "location_category": "Duty free", "avg_price_diff": "-0.97%", "interpretation": "slightly cheaper" },
        { "location_category": "Domestic", "avg_price_diff": "5.97%", "interpretation": "Expensively priced" }
      ], 
      "website_level_pricing_extremes": [ 
        { "website": "Heinemann Sydney", "avg_price_diff": "-0.97%", "interpretation": "slightly cheaper" },
       ...
      ], //show for top 5 expensive websites by difference percentage sorted from most expensive to least expensive
      "price_hotspots": [
        {  "product": "Chardonnay Some Liquor 250ml", "more_expensive_pct": "+50.00%" },
        ...
      ], //give top 10 price hotspots irrespective of the website
      ]
    }

    Note: only return the JSON data and nothing else. INCASE there is any problem doing that just say {error: "OpenAI unavailable at the moment"}
`;

export const summary_notes_fnb = `
   Format this JSON data into a below expected output JSON adding interpretation. (please dont return json with no post or pre text else it will throw error in frontend)

   Expected Output: (This data is just dummy to show the format, please do not hallucinate)
    {
      "terminal_level_price_trends": [
        { "terminal": "International Landside", "avg_price_diff": "-0.97%", "interpretation": "slightly cheaper" },
        ...
      ], 
      "price_hotspots": [
        { "terminal_store": "International Airside – Mexico", "item": "Beef Tacos", "more_expensive_pct": "+50.00%" },
        ...
      ], //give top 8 price hotspots irrespective of the terminal
      "store_level_pricing_extremes": [
        { "store": "Fresh Choice Mangere", "avg_price_diff": "-34.85%", "comment": "Most competitively priced (off-airport)" },
        ...
      ]
      ]
    }

    Note: only return the JSON data and nothing else. INCASE there is any problem doing that just say {error: "OpenAI unavailable at the moment"}
`;
